<script lang="ts" setup>
import SortIcon from '~/assets/icons/search/sorting.svg?component'
import FilterIcon from '~/assets/icons/search/filter.svg?component'
import CatalogSortingModal from '~/entities/catalog/products/modals/CatalogSortingModal.vue';
import CatalogFiltersModal from '~/entities/catalog/products/modals/CatalogFiltersModal.vue';
import useCatalogStore from '~/shared/store/modules/catalog';

const catalogStore = useCatalogStore();

const isAnyFilterActive = computed(() => {
  return Object.values(catalogStore.filters).some(filter => 
    filter.values.some(item => item.active)
  );
});

</script>

<template>
  <div class="catalog-filters catalog-filters_mobile">
    <div
      class="catalog-filters__block"
      @click="catalogStore.setSortingModalStatus(true)"
    >
      <SortIcon />
      {{catalogStore.sortingList[catalogStore.selectedFilters.sorting]}}
    </div>
    <div
      class="catalog-filters__block"
      @click="catalogStore.setFiltersModalStatus(true)"
    >
      Фильтры
      <div class="icon-container">
        <FilterIcon />
        <div v-if="isAnyFilterActive"  class="catalog-filters__block-indicator orange"></div>
      </div>
    </div>

    <Teleport to="body">
      <CatalogSortingModal/>
      <CatalogFiltersModal
        class="catalog-filters__modal"
      />
    </Teleport>
  </div>
</template>

<style lang="scss" scoped>
.catalog-filters {
  display: flex;
  justify-content: space-between;
  background-color: $bg_page;
  padding: 12px 0;

  &__modal {
    :deep(.mobile-modal__content) {
      right: 0 !important;
      opacity: 0 !important;
      pointer-events: none;
      transition: opacity .3s;
    }

    &.active {
      :deep(.mobile-modal__content) {
        opacity: 1 !important;
        pointer-events: auto;
      }
    }
  }

  &__block {
    display: flex;
    align-items: center;
    gap: 8px;
    @include font(16px, 20px, 500);

    &-indicator {
      position: absolute; 
      top: 8px; 
      right: 2px; 
      min-width: 12px; 
      height: 12px; 
      border: 2px solid white;
      border-radius: 50%; 
      background-color: $control-content_orange; 
      transform: translate(50%, -50%); 
    }
  }

  &__mobile {
    display: flex;
    align-items: center;
  }
}

.icon-container {
  position: relative;
  display: flex;
}
</style>
